import React, { useState, useEffect } from 'react';
import {
  Container,
  Form,
  Button,
  ToggleButton,
  ToggleButtonGroup,
} from 'react-bootstrap';
import FormInput from '../../common/FormInput';
import FormLabel from '../../common/FormLabel';
import Select from 'react-select';
import { HiOutlineChevronLeft } from '@react-icons/all-files/hi/HiOutlineChevronLeft';
import { useHistory, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { PARTNER_CHALLENGES } from '../../../constants/routes.constants';
import { ErrorMessage } from '@hookform/error-message';
import { useAuth } from '../../auth/Auth';
import { nextChallengeViewModel } from '../next_challenge/next.challenge.viewmodel';
import { schoolViewModel } from '../school/school.view.model';
import PartnerHeader from '../school/PartnerHeader';
import PartnerUnverifiedModal from '../school/PartnerUnverifiedModal';
import { partnerViewModel } from '../school/partner.view.model';
import { addTreehouseChallenge } from '../../../constants/error.constants';
import dropDownIc from '../../../assets/icon/tag-selectbox-arrow.svg';
import timezones from 'timezones-list';
import UploadSection from '../school/media_upload/UploadSection';
import LoadButton from '../../common/LoadButton';

const PartnerEditChallenge = () => {
  const history = useHistory();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [youtubeUrl, setYoutubeUrl] = useState('');
  const [youtubeErrors, setYoutubeErrors] = useState(false);
  const [challengeScope, setChallengeScope] = useState('private');
  const [time, setTime] = useState('');
  const [date, setDate] = useState('');
  const [endTime, setEndTime] = useState('');
  const [endDate, setEndDate] = useState('');
  const [image, setImage] = useState();
  const [isDisable, setIsDisable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [imageName, setImageName] = useState('');
  const { fetchAPI } = useAuth();
  const { cid } = useParams();
  const [challengeDetails, setChallengeDetails] = useState(null);
  const [selectedTag, setSelectedTag] = useState([]);
  const [isSpecial, setIsSpecial] = useState(false);
  const [timezone, setTimezone] = useState('');
  const [isRoots, setIsRoots] = useState(null);
  const [specialTime, setSpecialTime] = useState();
  const [specialDate, setSpecialDate] = useState();
  const [zoomLink, setZoomLink] = useState();
  const [selectedFriend, setSelectedFriend] = useState(null);
  const [uploadType, setUploadType] = useState('picture');
  const [picturePreview, setPicturePreview] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [video, setVideo] = useState(null);
  const [videoUrl, setVideoUrl] = useState('');
  const [showImageError, setShowImageError] = useState(false);
  const [imageError, setImageError] = useState('');
  const [videoError, setVideoError] = useState('');
  const { register, watch, handleSubmit, setError, errors, getValues } =
    useForm({
      mode: 'onBlur',
    });
  const [branchOptions, setBranchOptions] = useState([]);
  const taletreeFriendOptions = [
    { value: 'letsgo', label: 'LetsGo' },
    { value: 'uni', label: 'Uni' },
    { value: 'rushmore', label: 'Rushmore' },
    { value: 'cody', label: 'Cody' },
    { value: 'rooty', label: 'Rooty' },
    { value: 'doma', label: 'Doma' },
  ];

  const planOptions = [
    { value: 'all', label: 'All' },
    { value: 'seedlings', label: 'Seedlings and Villagers' },
    { value: 'villagers', label: 'Villagers only' },
  ];

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 'auto',
      color: '#321b6d',
      fontWeight: '400',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#321b6d',
    }),
    menu: (provided) => ({
      ...provided,
    }),
  };

  const getInterestBranches = () => {
    fetchAPI(nextChallengeViewModel.getTags, { limit: 99 })
      .then((res) => {
        res.map((tag) => {
          setBranchOptions((branchOptions) => [
            ...branchOptions,
            { value: tag.id, label: tag.tag },
          ]);
        });
      })
      .catch((err) => {});
  };

  const pageRedirect = () => {
    history.goBack();
  };

  const addZero = (data) => {
    let tempTime = data;
    if (tempTime < 10) {
      tempTime = '0' + tempTime;
    }
    return tempTime;
  };

  const getChallengeDetail = () => {
    fetchAPI(nextChallengeViewModel.getChallengeDetails, cid)
      .then((res) => {
        if (res.special_camp?.id) {
          setIsSpecial(true);
          setIsRoots(res.special_camp?.is_root);
          setTimezone(res.special_camp?.time_zone);
          setZoomLink(res.special_camp?.zoom_link);
          setSpecialDate(res.special_camp?.start_date.slice(0, 10));
          let tempSpecialtime = new Date(res.special_camp?.start_date);
          setSpecialTime(
            addZero(tempSpecialtime.getHours()) +
              ':' +
              addZero(tempSpecialtime.getMinutes())
          );
        }
        let startTime = new Date(res.start_date_time);
        let tempEndTime = new Date(res.end_date_time);
        setChallengeDetails(res);
        setTitle(res.title);
        setChallengeScope(res.challenge_scope);
        setDescription(res.description);
        setYoutubeUrl(res.youtube_url);
        setDate(res.start_date_time.slice(0, 10));
        setImageName(res.picture_url);
        setPicturePreview(res.picture_url);
        setTime(
          addZero(startTime.getHours()) + ':' + addZero(startTime.getMinutes())
        );
        setEndDate(res.end_date_time.slice(0, 10));
        setEndTime(
          addZero(tempEndTime.getHours()) +
            ':' +
            addZero(tempEndTime.getMinutes())
        );
        setSelectedFriend(
          res.character_type === '' ? null : res.character_type
        );
        res.tag_list.map((tag) => {
          setSelectedTag((selectedTag) => [
            ...selectedTag,
            { value: tag.id, label: tag.tag },
          ]);
        });
        setVideoUrl(res.video_url);
        setVideoPreview(res.video_url);
      })
      .catch((error) => setIsDisable(false));
  };

  const onSubmit = handleSubmit(() => {
    let isValid = true;

    // Check for image validation if the uploadType is 'picture'
    if (uploadType === 'picture' && !image && !challengeDetails?.picture_url) {
      setImageError('Please select an image.');
      isValid = false;
    } else {
      setImageError('');
    }

    // Check for video or youtube URL validation if the uploadType is 'video'
    if (
      uploadType === 'video' &&
      !video &&
      !youtubeUrl &&
      !challengeDetails?.video_url
    ) {
      setVideoError('Please select a video or enter a YouTube URL.');
      isValid = false;
    } else {
      setVideoError('');
    }

    if (!isValid) return; // Prevent further submission if validation fails
    setIsDisable(true);
    setIsLoading(true);
    let tags = [];
    selectedTag.map((tag) => {
      tags.push(tag.value);
    });
    let data = {
      title: title,
      description: description,
      challenge_scope: challengeScope,
      tags: tags,
      deadline: 7,
      youtube_url: youtubeUrl ? youtubeUrl : null,
    };
    if (selectedFriend) {
      data.character_type = selectedFriend;
    }
    if (date) {
      data.start_date_time = new Date(date + ' ' + time);
    }
    if (endDate) {
      data.end_date_time = new Date(endDate + ' ' + endTime);
    }
    if (isSpecial) {
      data.special_camp = {
        start_date_time: new Date(specialDate + ' ' + specialTime),
        name: title,
        zoom_link: zoomLink,
        description: description,
        time_zone: timezone,
        is_root: isRoots,
      };
    }
    if (uploadType === 'picture') {
      data.video_url = null;
    } else {
      data.picture_url = null;
      if (!video) {
        data.video_url = null; // if no video is selected
      }
    }
    schoolViewModel
      .editChallenge(cid, data)
      .then((res) => {
        handleMediaUpload();
      })
      .catch((err) => {
        console.log(err);
      });
  });

  const handleMediaUpload = () => {
    if (uploadType === 'picture') {
      if (image) {
        partnerViewModel
          .addPartnerChallengeMedia(cid, image)
          .then((res) => {
            handleRedirect();
          })
          .catch((err) => console.log(err));
      } else {
        handleRedirect();
      }
    }
    if (uploadType === 'video') {
      if (video) {
        schoolViewModel
          .addChallengeVideo(cid, video)
          .then((res) => {
            handleRedirect();
          })
          .catch((err) => console.log(err));
      } else {
        schoolViewModel
          .deleteChallengeVideo(cid)
          .then((res) => {})
          .catch((err) => console.log(err));
        if (!image && !video) {
          handleRedirect();
        }
      }
    } else {
      schoolViewModel
        .deleteChallengeVideo(cid)
        .then((res) => {})
        .catch((err) => console.log(err));
    }
  };

  const handleRedirect = () => {
    history.push(PARTNER_CHALLENGES);
  };

  const handleScopeChange = (val) => {
    setChallengeScope(val);
  };

  const handleBranchAdd = (selectedValue) => {
    setSelectedTag(selectedValue);
  };

  useEffect(() => {
    getChallengeDetail();
    getInterestBranches();
  }, []);

  const handleYoutube = (e) => {
    if (e.target.value === '') {
      setYoutubeErrors(false);
      setIsDisable(false);
    } else {
      var regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
      var match = e.target.value.match(regExp);
      if (match && match[2].length == 11) {
        setYoutubeErrors(false);
        setIsDisable(false);
      } else {
        setIsDisable(true);
        setYoutubeErrors('Please enter a valid url');
      }
    }
    setYoutubeUrl(e.target.value);
    setVideoError(null);
  };

  const handleTimezoneChange = (selected) => {
    setTimezone(selected.tzCode);
  };

  const handleFriendChoose = (e) => {
    setSelectedFriend(e.value);
  };

  const handlePlanChoose = (e) => {
    if (e.value === 'villagers') {
      setIsRoots(true);
    } else {
      setIsRoots(false);
    }
  };

  return challengeDetails ? (
    <div className="partner-wrapper-main">
      <PartnerHeader />
      <PartnerUnverifiedModal
        showModal={showModal}
        setShowModal={setShowModal}
      />
      <div className="add-more-branches partner_add_challenges">
        <span className="back-btn" onClick={pageRedirect}>
          <HiOutlineChevronLeft />
        </span>
        <Container>
          <div className="d-flex justify-content-center">
            <div>
              <h2 className="mb-50">
                Edit challenge for "<span>{challengeDetails.title}</span>"
              </h2>
              <Form className="mb-40" onSubmit={onSubmit}>
                <Form.Group className="mb-3" controlId="">
                  <FormLabel>Title</FormLabel>
                  <FormInput
                    name="title"
                    className="form-input"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="title"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    name="description"
                    as="textarea"
                    rows="3"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="description"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <ToggleButtonGroup
                  className="radio_styles"
                  type="radio"
                  name="challenge_scope"
                  value={challengeScope}
                  onChange={handleScopeChange}
                >
                  <ToggleButton
                    id="tbg-radio-1"
                    value="public"
                    className={challengeScope === 'public' && 'gred-btn'}
                  >
                    Public
                  </ToggleButton>
                  <ToggleButton
                    id="tbg-radio-2"
                    value="private"
                    className={challengeScope === 'private' && 'gred-btn'}
                  >
                    Subscribers only
                  </ToggleButton>
                </ToggleButtonGroup>
                <Form.Group className="mb-3" controlId="">
                  <Form.Label>Select interest branches</Form.Label>
                  <Select
                    name="hash_tag"
                    options={branchOptions}
                    isMulti
                    styles={customStyles}
                    required
                    value={selectedTag}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: '6px',
                      colors: {
                        ...theme.colors,
                        primary: '#80e4e1',
                      },
                    })}
                    onChange={handleBranchAdd}
                    inputRef={register({
                      required: addTreehouseChallenge.hast_tag.required,
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="hash_tag"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="">
                  <FormLabel>Challenge start date</FormLabel>
                  <div className="input-wrapper">
                    <FormInput
                      type="date"
                      name="date"
                      min={
                        date ? new Date(date).toISOString().slice(0, 10) : ''
                      }
                      className="form-input"
                      defaultValue={date}
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="date"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="">
                  <FormLabel>Challenge start time</FormLabel>
                  <div className="input-wrapper">
                    <FormInput
                      type="time"
                      name="time"
                      className="form-input"
                      defaultValue={time}
                      onChange={(e) => setTime(e.target.value)}
                    />
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="time"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="">
                  <FormLabel>Challenge end date</FormLabel>
                  <div className="input-wrapper">
                    <FormInput
                      type="date"
                      name="endDate"
                      min={
                        date ? new Date(date).toISOString().slice(0, 10) : ''
                      }
                      className="form-input"
                      defaultValue={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="endDate"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="">
                  <FormLabel>Challenge end time</FormLabel>
                  <div className="input-wrapper">
                    <FormInput
                      type="time"
                      name="endTime"
                      className="form-input"
                      defaultValue={endTime}
                      onChange={(e) => setEndTime(e.target.value)}
                    />
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="endTime"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="">
                  <Form.Label>Set time to complete</Form.Label>
                  <select className="form-select challenge-style">
                    <option value="7">1 week</option>
                  </select>
                  <img className="select-caret" src={dropDownIc} alt="" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="">
                  <Form.Label>Select TaleTree friend</Form.Label>
                  <Select
                    value={
                      selectedFriend &&
                      taletreeFriendOptions[
                        taletreeFriendOptions.findIndex((obj) => {
                          return obj.value === selectedFriend;
                        })
                      ]
                    }
                    name="taletree_friend"
                    options={taletreeFriendOptions}
                    styles={customStyles}
                    // value={selectedFriend}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: '6px',
                      colors: {
                        ...theme.colors,
                        primary: '#80e4e1',
                      },
                    })}
                    onChange={handleFriendChoose}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="taletree_friend"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>

                {isSpecial ? (
                  <>
                    <Form.Group className="mb-3" controlId="">
                      <FormLabel>
                        Select a time within a challenge start and end date for
                        your live event!
                      </FormLabel>
                      <FormInput
                        name="zoom_link"
                        className="form-input"
                        placeholder="Enter link to zoom / google meets"
                        value={zoomLink}
                        onChange={(e) => setZoomLink(e.target.value)}
                        ref={register({
                          required: addTreehouseChallenge.zoom_link.required,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="zoom_link"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="">
                      <FormLabel>Event start time</FormLabel>
                      <FormInput
                        type="time"
                        name="specialTime"
                        className="form-input"
                        defaultValue={specialTime}
                        onChange={(e) => setSpecialTime(e.target.value)}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="specialTime"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="">
                      <FormLabel>Event start date</FormLabel>
                      <FormInput
                        type="date"
                        name="specialDate"
                        min={
                          date
                            ? new Date(date).toISOString().slice(0, 10)
                            : new Date().toISOString().slice(0, 10)
                        }
                        max={
                          endDate &&
                          new Date(endDate).toISOString().slice(0, 10)
                        }
                        className="form-input"
                        value={specialDate}
                        onChange={(e) => setSpecialDate(e.target.value)}
                        ref={register({
                          required: addTreehouseChallenge.endDate.required,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="specialDate"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="">
                      <Form.Label>Time zone</Form.Label>
                      <Select
                        defaultValue={
                          timezones[
                            timezones.findIndex((obj) => {
                              return obj.tzCode === timezone;
                            })
                          ]
                        }
                        options={timezones}
                        styles={customStyles}
                        name="timezone"
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: '6px',
                          colors: {
                            ...theme.colors,
                            primary: '#80e4e1',
                          },
                        })}
                        onChange={handleTimezoneChange}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="timezone"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="">
                      <Form.Label>Select plan</Form.Label>
                      <Select
                        value={
                          isRoots &&
                          planOptions[
                            planOptions.findIndex((obj) => {
                              return (obj.value === isRoots) === true
                                ? 'villagers'
                                : 'all';
                            })
                          ]
                        }
                        name="plan"
                        options={planOptions}
                        styles={customStyles}
                        required
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: '6px',
                          colors: {
                            ...theme.colors,
                            primary: '#80e4e1',
                          },
                        })}
                        onChange={handlePlanChoose}
                        inputRef={register({
                          required: addTreehouseChallenge.plan.required,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="plan"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </>
                ) : (
                  ''
                )}
                <UploadSection
                  uploadType={uploadType}
                  setUploadType={setUploadType}
                  setImageName={setImageName}
                  setImage={setImage}
                  setShowImageError={setShowImageError}
                  video={video}
                  setVideo={setVideo}
                  handleYoutube={handleYoutube}
                  setYoutubeUrl={setYoutubeUrl}
                  picturePreview={picturePreview}
                  setPicturePreview={setPicturePreview}
                  videoPreview={videoPreview}
                  setVideoPreview={setVideoPreview}
                  youtubeUrl={youtubeUrl}
                  setImageError={setImageError}
                  setNoVideoError={setVideoError}
                />
                {imageError && <div className="text-danger">{imageError}</div>}
                {videoError && <div className="text-danger">{videoError}</div>}
                {youtubeErrors && (
                  <div className="text-danger">{youtubeErrors}</div>
                )}
                <LoadButton
                  type="submit"
                  text="Save Changes"
                  className="common-round-btn submit-btn mt-5 w-100 gred-btn"
                  isDisabled={isDisable}
                  isLoading={isLoading}
                />
              </Form>
            </div>
          </div>
        </Container>
      </div>
    </div>
  ) : (
    ''
  );
};
export default PartnerEditChallenge;
